<script>
import axios from 'axios';
import router from '@/router';
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';
import { authFackMethods } from '@/state/helpers';
import Swal from 'sweetalert2';
export default {
	page: {
		title: 'Volunteer System',
		meta: [
			{
				name: 'Volunteer System',
			},
		],
	},
	components: { Header, Footer },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			submitData: {
				user_type_id: '',
				status: 'applicant',
			},
			isDisable: true,
			isShow: false,
			selected: false,
			isAdditional: false,
			isOpportunities: false,
			isBackground: false,
			isEmployment: false,
			isFaith: false,
			isPersonalInfo: false,
			isQuestion: false,
			isReference: false,
			errors: [],
			applicationNotSubmitted: true,
			userStatus: null,
			enableConditions: true,
			userData: JSON.parse(localStorage.getItem('web_user')),
			userRoles: JSON.parse(localStorage.getItem('selectedRoles')),
		};
	},
	mounted() {
		this.getSubmitFormStats();
	},
	created() {
		this.formSubmissionChecker();
		this.getContactDetail();
	},
	methods: {
		...authFackMethods,
		backgroundCheck() {
			router.push({ name: 'mentor-background-check' });
		},
		references() {
			router.push({ name: 'mentor-references' });
		},
		submitApplication() {
			const userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData['token'] },
			};
			if (userData['token']) {
				this.submitData.user_type_id = 3; // mentor
				axios
					.post('user/registration/mentor_submission', this.submitData, config)
					.then((res) => {
						if (res.status == 200) {
							this.isDisable = true;
							router.push({ name: 'mentor-thankyou' });
						}
					})
					.catch((err) => {
						if (err.response) {
							this.isShow = true;
							this.errors = err.response.data.error.message;
						}
					});
			}
		},

		// Getting Current User Forms States
		getSubmitFormStats() {
			this.isAdditional = false;
			this.isBackground = false;
			this.isEmployment = false;
			this.isFaith = false;
			this.isPersonalInfo = false;
			this.isQuestion = false;
			this.isReference = false;
			this.isDisable = true;
			var userData = JSON.parse(localStorage.getItem('web_user'));
			var config = {
				headers: { Authorization: 'Bearer ' + userData['token'] },
			};
			if (userData.token) {
				axios
					.get('user/registration/submitted-forms?user_type_id=' + userData['user_type_id'], config)
					.then((res) => {
						if (res.data.response.additional_details) {
							this.isAdditional = true;
							this.isDisable = false;
						}
						if (res.data.response.background) {
							this.isBackground = true;
							this.isDisable = false;
						}
						if (res.data.response.employment) {
							this.isEmployment = true;
							this.isDisable = false;
						}
						if (res.data.response.faith) {
							this.isFaith = true;
							this.isDisable = false;
						}
						if (res.data.response.personal_info) {
							this.isPersonalInfo = true;
							this.isDisable = false;
						}
						if (res.data.response.question) {
							this.isQuestion = true;
							this.isDisable = false;
						}
						if (res.data.response.reference) {
							this.isReference = true;
							this.isDisable = false;
						}
						if (res.data.response.opportunity) {
							this.isOpportunities = true;
							this.isDisable = false;
						}
					})
					.catch((err) => {
						if (err.response) {
							if (err.response.status == 404) {
								console.log('No Record Found');
							}
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		formSubmissionChecker() {
			var config = {
				headers: { Authorization: 'Bearer ' + this.userData.token },
			};

			axios
				.get(`user/registration/registration-check?user_id=${this.userData.id}&user_type_id=3`, config)
				.then((res) => {
					if (res.data.response.registration == true) {
						this.applicationNotSubmitted = false;
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 404) {
							console.log('No Record Found');
						}
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		getContactDetail() {
			var token = this.userData.token;
			//   var token = localStorage.getItem('token');
			var config = {
				headers: { Authorization: 'Bearer ' + token },
			};
			if (token) {
				axios
					.get('user/' + this.userData.id, config)
					.then((res) => {
						if (res.status == 200) {
							this.userStatus = res.data.response.status;
						}
					})
					.catch((err) => {
						if (err.response) {
							if (err.response.status == 404) {
								console.log('No Record Found');
							}
							if (err.response.status == 401) {
								this.logout();
							}
						}
					});
			}
		},
		addAssignment() {
			if (this.userRoles) {
				var roles_length = this.userRoles.length;

				if (roles_length > 0) {
					var role_id = this.userRoles[0] ? this.userRoles[0] : 0;
					var formData = new FormData();
					var userData = JSON.parse(localStorage.getItem('web_user'));
					var volunteers = [userData['id']];
					// formData.append('user_id',userData['id']);
					formData.append('user_type_id', userData['user_type_id']);
					formData.append('location_id', userData['location_id']);
					// formData.append('building_id',"")
					// formData.append('department_id',"")
					formData.append('role_id', role_id);
					formData.append('volunteers', volunteers);
					// formData.append('approver_id',1)
					// formData.append('started_at',moment('0000-00-00','YYYY-MM-DD').format('YYYY-MM-DD'))
					// formData.append('ended_at',moment('0000-00-00','YYYY-MM-DD').format('YYYY-MM-DD'))
					formData.append('status', 'awaiting_approval');

					formData.append('days[]', 'someday');
					formData.append('time' + '[someday]' + '[start]', '');
					formData.append('time' + '[someday]' + '[end]', '');

					var token = userData['token'];
					var config = {
						headers: {
							Authorization: 'Bearer ' + token,
							Accept: 'application/json',
						},
					};
					if (token) {
						axios
							.post('user/assignments', formData, config)
							.then(() => {
								localStorage.removeItem('selectedRoles');
							})
							.catch(async (err) => {
								if (err.response) {
									await Swal.fire({
										title: 'Error!',
										text: err.response.data?.error?.message || err.response.data?.message,
										icon: 'error',
										width: 350,
										showConfirmButton: true,
									});
								}
							});
					}
				} //if role is selected
			} //if having user roles
		},

		gotoRoles() {
			router.push({ name: 'volunteer-roles' });
		},
		gotoMentorHours() {
			router.push({ name: 'mentor-hours' });
		},
		loginPage() {
			router.push({ name: 'login' });
		},
		gotoProfile() {
			router.push({ name: 'profile' });
		},
		gotoApplication() {
			router.push({ name: 'review-application' });
		},
		contactt() {
			router.push({ name: 'contact' });
		},
	},
};
</script>

<template>
	<div>
		<Header></Header>
		<div id="main-title" class="secondary">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-6 align-self-center">
						<h3 class="title">Become a Mentor</h3>
					</div>
					<div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
						<p class="need-help">Need Help ? <a @click="contactt" href="javascript:">Contact Us</a></p>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-form d-flex container pb-5 pt-5" v-if="!enableConditions">
			<b-button class="btn-custom ms-0" variant="custom" @click="gotoProfile"> Profile Information </b-button>
		</div>

		<div id="create-account">
			<div class="container">
				<form class="custom-form">
					<div class="row">
						<div class="col-12 mb-5">
							<h3 class="main-title">Review Application</h3>
						</div>
						<div v-show="isShow" class="alert alert-danger col-12">
							<span class="d-block" v-for="(error, index) in errors" :key="index">- {{ error }}</span>
						</div>
					</div>

					<!-- volunteer block -->
					<div class="row">
						<div class="col-12 col-md-3">
							<b-button @click="backgroundCheck" variant="review">
								<i class="bx bx-check" :class="{ selected: isBackground }"></i>
								Background Check
								<a href="javascript:" class="rvw-link">Review</a>
							</b-button>
						</div>
						<div class="col-12 col-md-3">
							<b-button @click="references" variant="review">
								<i class="bx bx-check" :class="{ selected: isReference }"></i>
								References
								<a href="javascript:" class="rvw-link">Review</a>
							</b-button>
						</div>
					</div>

					<div class="row justify-content-center">
						<div class="col-12 col-md-6">
							<div class="text-center mt-3" v-if="applicationNotSubmitted">
								<b-button :class="isDisable ? 'pe-none bg-secondary bg-soft' : ''" variant="custom" @click="submitApplication"> Submit Application </b-button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<Footer></Footer>
		<b-modal id="mentorApplicationComplete" centered size="lg" title="Your application has been submitted!" title-class="font-18" hide-footer>
			<div class="row">
				<div class="col-12">
					<p class="pb-0">Thank you for completing your application to become MNTC mentor. A member of our team will be reaching out to you directly if you are selected or if we need additional information.</p>
					<h4 class="fw-bold mb-3 mt-4 text-start">What to Expect?</h4>
					<p class="mt-2 text-start pb-0">We will communicate acceptance or rejection of you application with X Business Days</p>
					<p class="mt-2 text-start pb-0">We will be connecting with your references listed in the application</p>
					<p class="mt-2 text-start pb-0">All applicants will be subject to a background check</p>
					<p class="mt-2 text-start pb-0">If accepted, we will reach out to schedule orientation with the MNTC team</p>
					<div class="d-flex justify-content-center mb-5">
						<b-button type="button" @click="$bvModal.hide('mentorApplicationComplete')" variant="custom">Visit MNTC.ORG</b-button>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>
